var _ = require('lodash');

module.exports = {
  /* global L */
  _popupLatLng: null,

  // this flag is used to prevent a race condition where dragging sometimes
  // triggers a map click that will set the layer to inactive when it shouldn't

  // next two flags are so that we can correctly set the layer to inactive when
  // the map is clicked twice.
  _mapClicksAfterPopupClose: 0,
  _fudgeMapClickAfterCloseCount: false,

  popupClosedByUser: false,

  initializePopup: function () {
    this.map.on('click', this.onMapClickForPopup, this);
  },

  cleanupPopup: function () {
    this.map.off('click', this.onMapClickForPopup, this);
  },

  addPopupEventListeners: function () {
    this.on('popupopen', this.onPopUpOpen, this);
    this.on('popupclose', this.onPopUpClose, this);
  },

  /**
   * Create the popup dialog
   * @returns {[type]} [description]
   */
  createPopup: function () {
    // NOTE: popup content is not set here. It is retrieved from the Store and
    // set later

    var leafletLayer = this.leafletLayer;
    var latlng = this._getPopupLatLng();
    var options = this._getPopupOptions();
    var popup = L.popup(options, leafletLayer).setLatLng(latlng);

    this.addPopupEventListeners();

    return popup;
  },

  showPopup: function (latlng) {

    if (!this._shouldOpenPopup()) {
      return;
    }

    // HACK... for AU
    // Not a viable long term solution
    setTimeout(function () {
      var dialogPopup = this.dialogPopup;
      var content = this.Store.get('activeLayerPopupContent');

      // popup can be shown if clickable
      if (!this.isClickable()) {
        return;
      }

      latlng = latlng || this._popupLatLng || this._getPopupLatLng();

      if (!this.isPopupOpen) {

        // Create the popup if not yet created
        // TODO @andre when should this.dialogPopup be set to null?
        if (!dialogPopup) {
          dialogPopup = this.dialogPopup = this.createPopup();
        }

        if (content) {
          this.setPopupContent(content);
        } else {
          console.warn('No popup content...');
          this.hidePopup();
          return;
        }

        this.map.addLayer(dialogPopup);

        setTimeout(function () {
          dialogPopup._updateLayout();
          dialogPopup._updatePosition();
        }, 10);

        if (this.Store.get('activeLayer') && this.Store.get('activeLayer').type) {
          dialogPopup._container.classList.add(this.Store.get('activeLayer').type);
        }
      }

      this.movePopup(latlng);
    }.bind(this), 100);
  },

  /**
   * Hides the popup.
   *
   * @param  {Boolean} incrementMapClickCount HACK used to fudge the map click count
   * because when the hidepopup is triggered from outside leaflet the first click
   * does not get picked up for some reason
   * @returns {void}
   */
  hidePopup: function (incrementMapClickCount) {
    var map = this.map;
    var dialogPopup = this.dialogPopup;

    if (this.isPopupOpen) {
      this._fudgeMapClickAfterCloseCount = incrementMapClickCount;

      map.removeLayer(dialogPopup);
    }
  },

  movePopup: function (latlng) {
    this.setPopupLatLng(latlng);
    this.dialogPopup.setLatLng(latlng);
  },

  /**
   * @param {Object} content jqLite object
   * @returns {void}
   */
  setPopupContent: function (content) {
    var div = document.createElement('div');
    _.forEach(content, function (c) {
      // NOTE: appendChild removes the node from its current position in the DOM
      div.appendChild(c);
    });
    this.dialogPopup.setContent(div);
  },

  setPopupLatLng: function (latlng) {
    this._popupLatLng = latlng;
  },

  /**
   * Get the default anchor position of the edit dialog popup
   * @returns {Object} latlng
   */
  _getPopupLatLng: function () {
    // noop... child override
  },

  /**
   * Retrieve options to be apply to the edit dialog popup
   *
   * @see http://leafletjs.com/reference.html#popup-options
   * @returns {Object} popup options
   */
  _getPopupOptions: function () {

    var offset = this.layer.data.properties.popupOffset || [0, 6];
    var paddingTopLeft = L.point(60, 75);
    var paddingBottomRight = L.point(75, 60);

    return {
      offset: offset,
      closeButton: false,
      maxWidth: 300,
      className: 'layer-edit-dialog',
      autoPanPaddingTopLeft: paddingTopLeft,
      autoPanPaddingBottomRight: paddingBottomRight
    };
  },

  _shouldOpenPopup: function () {
    if (this.popupClosedByUser) {
      return false;
    }

    return true;
  },

  onPopUpOpen: function () {
    var container = this.dialogPopup._container;

    this.isPopupOpen = true;
    this._mapClicksAfterPopupClose = 0;

    L.DomEvent.addListener(container, 'click', this.onPopUpContainerClicked, this);
  },

  /**
   * Fired when the popup is closed.
   * @returns {void}
   */
  onPopUpClose: function () {
    var container = this.dialogPopup._container;

    this.isPopupOpen = false;

    if (this._fudgeMapClickAfterCloseCount) {
      this._mapClicksAfterPopupClose = 1;
      this._fudgeMapClickAfterCloseCount = false;
    } else {
      this._mapClicksAfterPopupClose = 0;
    }

    this.Actions.CloseActiveLayerPopup.dispatch(this.layer);

    L.DomEvent.removeListener(container, 'click', this.onPopUpContainerClicked);
  },

  onPopUpContainerClicked: function (e) {
    e.stopPropagation();
  },

  onMapClickForPopup: function () {
    if (this.isActive) {
      if (!this.isPopupOpen) {
        this._mapClicksAfterPopupClose++;
        if (this._mapClicksAfterPopupClose >= 1) {
          this.setInactive();
        }
      } else {
        this.popupClosedByUser = true;
      }
    }
  }
};



// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/map/src/app/layer/edit/base/mixins/PopupMixin.js